export function stripQuotes(str: string) {
    let value = str;

    if (value.startsWith('"')) {
        value = value.slice(1);
    }

    if (value.endsWith('"')) {
        value = value.slice(0, -1);
    }

    value = value.replaceAll('""', '"');

    return value;
}
